import { lazy } from "react"
import { RouteProps } from "../features.types"

const AdminController = lazy(() => import("./admin-controller"))
const ApproveVehicles = lazy(() => import("./approve-vehicles"))
const AdminHome = lazy(() => import("./all-vehicles"))
const ExtraPayments = lazy(() => import("./offline-payment/extra-payments"))
const Reminders = lazy(() => import("./reminders"))
const SendEmail = lazy(() => import("./send-email"))
const SendDeviceNotifications = lazy(
  () => import("./send-device-notifications")
)
const SendAppNotification = lazy(
  () => import("./send-email/send-modal-notification")
)
const OfflinePayment = lazy(() => import("./offline-payment"))
const ProcessOrders = lazy(() => import("./process-orders"))
const UpdateProfile = lazy(() => import("./update-profile"))
const CreditAccount = lazy(() => import("./credit-account"))
const AdminDashboard = lazy(() => import("./dashboard"))
const TenantOrders = lazy(() => import("./tenant-orders"))
const Expenses = lazy(() => import("./expenses"))

// define route constant
export const ADMIN_ROUTE = "admin"
export const APPROVE_VEHICLES_ROUTE = "admin/approve-vehicles"
export const EXTRA_PAYMENT_ROUTE = "admin/extra-payments"
export const REMINDER_ROUTE = "admin/reminders"
export const SEND_EMAIL_ROUTE = "admin/send-email"
export const SEND_DEVICE_NOTIFICATIONS_ROUTE =
  "admin/send-device-notifications"
export const SEND_MODAL_NOTIFICATION_ROUTE = "admin/send-modal-notification"
export const OFFLINE_PAYMENT_ROUTE = "admin/offline-payment"
export const PROCESS_ORDERS_ROUTE = "admin/process-orders"
export const UPDATE_PROFILE_ROUTE = "admin/update-profile"
export const CREDIT_ACCOUNT_ROUTE = "admin/credit-account"
export const ADMIN_DASHBOARD_ROUTE = "admin/dashboard"
export const TENANT_ORDERS_ROUTE = "admin/tenant-orders"
export const EXPENSES_ROUTE = "admin/expenses"

//define routes
export const Admin: RouteProps[] = [
  {
    path: `${ADMIN_ROUTE}`,
    Component: AdminController,
    children: [
      {
        index: true,
        Component: AdminHome,
      },
      {
        path: `/${APPROVE_VEHICLES_ROUTE}`,
        Component: ApproveVehicles,
      },
      {
        path: `/${SEND_EMAIL_ROUTE}`,
        Component: SendEmail,
      },
      {
        path: `/${SEND_DEVICE_NOTIFICATIONS_ROUTE}`,
        Component: SendDeviceNotifications,
      },
      {
        path: `/${SEND_MODAL_NOTIFICATION_ROUTE}`,
        Component: SendAppNotification,
      },
      {
        path: `/${REMINDER_ROUTE}`,
        Component: Reminders,
      },
      {
        path: `/${EXTRA_PAYMENT_ROUTE}`,
        Component: ExtraPayments,
      },
      {
        path: `/${OFFLINE_PAYMENT_ROUTE}`,
        Component: OfflinePayment,
      },
      {
        path: `/${PROCESS_ORDERS_ROUTE}`,
        Component: ProcessOrders,
      },
      {
        path: `/${UPDATE_PROFILE_ROUTE}`,
        Component: UpdateProfile,
      },
      {
        path: `/${CREDIT_ACCOUNT_ROUTE}`,
        Component: CreditAccount,
      },
      {
        path: `/${ADMIN_DASHBOARD_ROUTE}`,
        Component: AdminDashboard,
      },
      {
        path: `/${TENANT_ORDERS_ROUTE}`,
        Component: TenantOrders,
      },
      {
        path: `/${EXPENSES_ROUTE}`,
        Component: Expenses,
      },
    ],
  },
]
